/*! Blaze mobile menu motion — v19 coordinated open/close + CTA press (preview) */
(function () {
  if (window.__blazeMenuMotion) return;
  window.__blazeMenuMotion = true;

  var OPEN_MS = 220;
  var CLOSE_MS = 180;
  var CTA_PRESS_MS = 170;
  var reduce = false;
  try {
    reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var closing = false;

  function panel() {
    return document.querySelector('#header .dropdown_container[data-dropdown="mobile_menu"]');
  }

  function hamburger() {
    return document.querySelector('a.mobile_nav.dropdown_link[data-dropdown-rel="mobile_menu"] div');
  }

  function menuIsOpen() {
    if (document.body.classList.contains('blaze-mm-closing')) return true;
    if (!document.body.classList.contains('is-active')) return false;
    var p = panel();
    if (!p) return false;
    var style = window.getComputedStyle(p);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function finishClose(p) {
    document.body.classList.remove('blaze-mm-closing');
    document.body.classList.remove('is-active');
    document.body.classList.remove('blocked-scroll');
    if (p) {
      p.classList.remove('blaze-mm-animating', 'blaze-mm-enter-from');
      p.style.display = 'none';
      p.style.transform = '';
      p.style.transition = '';
    }
    var ham = hamburger();
    if (ham) ham.classList.remove('open');
    closing = false;
  }

  function animateOpen() {
    var p = panel();
    if (!p) return;
    if (reduce) {
      p.classList.remove('blaze-mm-enter-from', 'blaze-mm-animating');
      return;
    }
    // Keep surface+content off-canvas together, then slide in as one unit
    p.classList.add('blaze-mm-enter-from', 'blaze-mm-animating');
    void p.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        p.classList.remove('blaze-mm-enter-from');
        setTimeout(function () {
          p.classList.remove('blaze-mm-animating');
        }, OPEN_MS + 30);
      });
    });
  }

  function animateClose(e) {
    if (closing) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var p = panel();
    closing = true;
    e.preventDefault();
    e.stopImmediatePropagation();
    document.body.classList.add('blaze-mm-closing');

    if (reduce) {
      finishClose(p);
      return;
    }

    if (p) {
      p.classList.add('blaze-mm-animating');
      if (p.style.display === 'none') p.style.display = 'flex';
      p.style.transition = 'transform 180ms ease-in';
      void p.offsetWidth;
      p.style.transform = 'translateX(100%)';
    }
    var ham = hamburger();
    if (ham) ham.classList.remove('open');

    setTimeout(function () {
      finishClose(p);
    }, CLOSE_MS);
  }

  function onCaptureClick(e) {
    var link = e.target.closest && e.target.closest('a.mobile_nav.dropdown_link[data-dropdown-rel="mobile_menu"]');
    if (!link) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 798px)').matches) return;

    if (menuIsOpen() || closing) {
      animateClose(e);
      return;
    }

    // Prime off-canvas BEFORE theme reveals the panel (avoids cream flash)
    var p = panel();
    if (p && !reduce) {
      p.classList.add('blaze-mm-enter-from');
    }
    setTimeout(animateOpen, 0);
  }

  function onCtaPress(e) {
    var a = e.target.closest && e.target.closest('#mobile_menu .blaze-mm__link--primary');
    if (!a) return;
    if (reduce) return;
    a.classList.add('is-pressed');
    setTimeout(function () {
      a.classList.remove('is-pressed');
    }, CTA_PRESS_MS);
  }

  document.addEventListener('click', onCaptureClick, true);
  document.addEventListener('pointerdown', onCtaPress, true);
})();
